import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IMonTuongDuong } from "../../model/respone/category/IMonTuongDuong";
import { apiClient } from "../apiClient";
export const MON_TUONG_DUONG_API = "mon-tuong-duong";
export const monTuongDuongApi = {
  SelectAll: () => apiClient.get(`${MON_TUONG_DUONG_API}`),
  Insert: (payload: IMonTuongDuong) => apiClient.post(`${MON_TUONG_DUONG_API}`, payload),
  Update: (payload: IMonTuongDuong) => apiClient.put(`${MON_TUONG_DUONG_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${MON_TUONG_DUONG_API}/${id}`),
  Deletes: (request: IIdsRequest) => apiClient.put(`${MON_TUONG_DUONG_API}/deletes`, request),
};
